export default {"src":"/_next/static/media/arrow_without_tail.9b94e1ae.svg","height":25,"width":25};